// extracted by mini-css-extract-plugin
export default {"brandLogo":"Logo_brandLogo__gU0id","AIText":"Logo_AIText__a-JuX","logoText":"Logo_logoText__WeAOZ"};